import { Component, OnInit, Injectable, Input, ViewChild, ElementRef } from '@angular/core';
import { CommonService } from '../../services/CommonService';
import { map } from 'rxjs/operators';
import 'firebase/database';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/storage';
import 'firebase/storage';

@Component({
  selector: 'app-price-table',
  templateUrl: './price-table.component.html',
  styleUrls: ['./price-table.component.css']
})
export class PriceTableComponent implements OnInit {
  priceNotice: any;
  priceTableTag: any;
  @ViewChild('myname') input: ElementRef;
  downloadURL: Observable<string | null>;

  constructor(private commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router,
    private storage: AngularFireStorage) {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.getListPriceNoticeDetail(this.input.nativeElement.value);
    }, 0);
  }

  ngOnInit(): void {
    this.getListPriceNotice();
    this.getListPriceNoticeDetail(this.input.nativeElement.value);
  }


  //get list menu bar
  getListPriceNotice() {
    this.commonService.getListPriceNotice().snapshotChanges().pipe(
      map(changes =>
        changes.map(c =>
          ({ key: c.payload.key, ...c.payload.val() })
        )
      )
    ).subscribe(priceTableTag => {
      this.priceTableTag = priceTableTag;
      console.log(this.priceTableTag);
    });
  }

  //get list sub menu
  getListPriceNoticeDetail(id: String) {
    this.commonService.getListPriceNoticeDetail(id).snapshotChanges().pipe(
      map(changes =>
        changes.map(c =>
          ({ key: c.payload.key, ...c.payload.val() })
        )
      )
    ).subscribe(priceNotice => {
      this.priceNotice = priceNotice;
      for (let index = 0; index < this.priceNotice.length; index++) {
        let downloadURL: Observable<string | null>;
        const ref = this.storage.ref(this.priceNotice[index].link);
        downloadURL = ref.getDownloadURL();
        this.priceNotice[index].link = downloadURL;
      }
      console.log(this.priceNotice);
    });
  }

}
